import { connect } from 'react-redux'

import LastOrders from '../components/LastOrders'

const mapStateToProps = (state) => {
  return {
    nativeAppInfo: state.native.nativeAppInfo,
  }
}

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(LastOrders)
